import { useEffect, useRef, useState } from "react";
import { Cpu, AlertTriangle, Sparkles } from "lucide-react";

// Edición REAL: el modelo IA seleccionado («ajustes») calcula los 13 básicos de cada foto.
// run(onProgress) → { edited, fallback, errors, fatal }.
export default function ProcessingStep({ count, run, onDone }) {
  const [done, setDone] = useState(0);
  const [total, setTotal] = useState(count);
  const [error, setError] = useState(null);
  const started = useRef(false);

  useEffect(() => {
    if (started.current) return;
    started.current = true;
    (async () => {
      try {
        const stats = await run((d, t) => { setDone(d); setTotal(t); });
        if (stats.fatal) setError(stats.fatal);
        onDone({ total: count, succeeded: count, failed: 0, aiEdited: stats.edited, aiFallback: stats.fallback, aiErrors: stats.errors, aiFatal: stats.fatal });
      } catch (e) {
        setError(e?.message || "Error en la edición IA");
        onDone({ total: count, succeeded: count, failed: 0, aiEdited: 0, aiFallback: count, aiErrors: [String(e?.message || e)], aiFatal: String(e?.message || e) });
      }
    })();
  }, [count, run, onDone]);

  const pct = total ? Math.round((done / total) * 100) : 0;

  return (
    <section className="animate-fade-up rounded-xl border border-zinc-800 bg-[#141418] p-8" data-testid="processing-step">
      <div className="flex items-center gap-3">
        <Cpu className="h-5 w-5 animate-pulse text-emerald-400" />
        <h2 className="font-display text-lg font-semibold">Edición IA en curso</h2>
      </div>
      <p className="mt-1.5 flex items-center gap-1.5 text-sm text-zinc-500">
        <Sparkles className="h-3.5 w-3.5 text-emerald-400" />
        El modelo IA seleccionado en «Ajustes» corrige los 13 básicos de cada foto (exposición, tono, balance de blancos, presencia y color). El preset aporta el resto de paneles.
      </p>
      <div className="mt-6 h-2 w-full overflow-hidden rounded-full bg-zinc-800">
        <div className="h-full rounded-full bg-emerald-400 transition-all duration-150" style={{ width: `${pct}%` }} />
      </div>
      <p className="mt-2 font-mono text-xs text-zinc-500" data-testid="processing-progress">
        {done} / {total} fotos · {pct}%
      </p>
      {error && (
        <p className="mt-3 flex items-start gap-2 text-xs text-amber-300" data-testid="processing-ai-error">
          <AlertTriangle className="mt-0.5 h-3.5 w-3.5 shrink-0" /> {error}. Las fotos sin respuesta usan el motor local.
        </p>
      )}
    </section>
  );
}
